import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const Checkbox = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M9.98625412,13.6483388 L6.66208471,10.3241694 L5,11.9884859 L9.98625412,17 L11.6483388,15.3104235 L18.2966777,8.66208471 L16.6345929,7 L9.98625412,13.6483388 Z M5,3 L19,3 C20.1045695,3 21,3.8954305 21,5 L21,19 C21,20.1045695 20.1045695,21 19,21 L5,21 C3.8954305,21 3,20.1045695 3,19 L3,5 C3,3.8954305 3.8954305,3 5,3 Z"
        />
    </StarryUIIcon>
);
